/* eslint-disable react-hooks/exhaustive-deps */
import globalText from "../../../../../utils/globalText";
import { globalTextFormat } from "../../../../../utils/globalTextFormat";
import AssignLabels from "../../../../_utils/AccountCreationComponents/AssignLabels";
import CommonLayout from "../../../../_utils/CommonLayout";
import DynamicAdditionalFields from "../../../../_utils/TransactionCommonComponents/DynamicAdditionalFields";

const InternalTransactionStepAdditionalDetails = ({
  showLabelModal,
  txnPayLoad,
  additionalData,
  setAdditionalData,
  hyperLink,
  setHyperLink,
  timeData,
  setTimeData,
  uploadedFiles,
  setUploadedFiles,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  selectedValue,
  setSelectedValue,
  selectedValueMonth,
  setSelectedValueMonth,
  initialRefactorAdditionalDetail,
  setInitialRefactorAdditionalDetail,
  previewImages,
  setPreviewImages,
  reminder_remark,
  quantity,
  setQuantity,
  setShowLabelModal,
  selectedLabelsCreate,
  flow,
  refactor,
}) => {
  return (
    <>
      <div
        className={`${showLabelModal && "fixed overflow-y-hidden"} ${reminder_remark !== null && flow === "ReminderFlow" ? "pt-padding-md" : refactor ? "pt-padding-md" : "lg:pt-padding-md pt-padding-md"} relative z-z-index-content w-width-full max-w-screen-lg px-padding-md lg:px-padding-base pb-padding-md snap-start flex flex-col gap-gap-md Qsmd:gap-gap-xl lg:flex-row justify-center`}
      >
        <CommonLayout>
          <DynamicAdditionalFields
            headerText={globalTextFormat(
              globalText.CATEGORY_SPECIFIC_DETAILS,
              [0, 1, 2],
            )}
            mergeCategory={txnPayLoad?.mergeCategory}
            additionalData={additionalData}
            setAdditionalData={setAdditionalData}
            hyperLink={hyperLink}
            setHyperLink={setHyperLink}
            timeData={timeData}
            setTimeData={setTimeData}
            quantities={quantity}
            setQuantities={setQuantity}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            selectedValueMonth={selectedValueMonth}
            setSelectedValueMonth={setSelectedValueMonth}
            initialRefactorAdditionalDetail={initialRefactorAdditionalDetail}
            setInitialRefactorAdditionalDetail={
              setInitialRefactorAdditionalDetail
            }
            previewImages={previewImages}
            setPreviewImages={setPreviewImages}
            onInputChanged={(name, value, dataType) => {
              setAdditionalData((prev) => ({
                ...prev,
                [name]: value,
              }));
            }}
          />

          <AssignLabels
            setLabelpopup={setShowLabelModal}
            labels={selectedLabelsCreate}
            subText1={globalText?.LABELS_USAGE_NOTE}
            subText2={globalText?.LABELS_AUTO_ASSIGNED_NOTE}
            isOptional={true}
          />
        </CommonLayout>
      </div>
    </>
  );
};

export default InternalTransactionStepAdditionalDetails;
